  <div [class]="model.ratingRootCss" #contentElement>
      <fieldset 
          [attr.role]="model.a11y_input_ariaRole"
          [attr.aria-required]="model.a11y_input_ariaRequired"
          [attr.aria-label]="model.a11y_input_ariaLabel"
          [attr.aria-labelledby]="model.a11y_input_ariaLabelledBy"
          [attr.aria-describedby]="model.a11y_input_ariaDescribedBy"
          [attr.aria-invalid]="model.a11y_input_ariaInvalid"
          [attr.aria-errormessage]="model.a11y_input_ariaErrormessage"
      >
          <legend role="presentation" class="sv-hidden"></legend>
          <span *ngIf="model.hasMinLabel" [class]="model.cssClasses.minText" [model]="model.locMinRateDescription" sv-ng-string>
          </span>
          <ng-template *ngFor="let item of model.renderedRateItems; index as index; trackBy: trackByFn" [component]="{ name: model.itemComponent, data: {model: model, item: item, index: index }}"></ng-template>
          <span *ngIf="model.hasMaxLabel" [class]="model.cssClasses.maxText" [model]="model.locMaxRateDescription" sv-ng-string></span>
      </fieldset>
  </div>
